export const iconFontAwesomeFoodBeverageSeedling = (
	<i className="fa-solid fa-seedling"></i>
);
